import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const LipSyncSection = () => {
  const navigate = useNavigate();
  
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-muted/30">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="space-y-6">
            <h2 className="text-3xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              Crie vídeos animados com LipSync
            </h2>
            <p className="text-muted-foreground">
              Transforme seus textos em vídeos animados com personagens que falam. Ideal para criação de conteúdo para redes sociais, educação ou entretenimento.
            </p>
            <ul className="space-y-2">
              <li className="flex items-start">
                <span className="bg-primary/20 text-primary p-1 rounded-full mr-2">✓</span>
                <span>Escolha entre personagens realistas ou de desenho animado</span>
              </li>
              <li className="flex items-start">
                <span className="bg-primary/20 text-primary p-1 rounded-full mr-2">✓</span>
                <span>Traduza textos do português para o inglês</span>
              </li>
              <li className="flex items-start">
                <span className="bg-primary/20 text-primary p-1 rounded-full mr-2">✓</span>
                <span>Gere vídeos sincronizados com áudio</span>
              </li>
              <li className="flex items-start">
                <span className="bg-primary/20 text-primary p-1 rounded-full mr-2">✓</span>
                <span>Compartilhe diretamente nas redes sociais</span>
              </li>
            </ul>
            <div className="flex flex-wrap gap-4">
              <Button 
                onClick={() => navigate("/lipsync-tutorial")}
                className="bg-primary text-primary-foreground hover:bg-primary/90"
              >
                Ver tutorial completo <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
              <Button 
                variant="outline" 
                onClick={() => window.open("https://lipsync.video/", "_blank")}
              >
                Visitar site oficial
              </Button>
            </div>
          </div>
          
          <div className="rounded-lg overflow-hidden shadow-lg bg-card">
            <div className="aspect-video relative bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center">
              <img 
                src="https://storage.googleapis.com/fenado-ai-farm-public/generated/8cf5a3da-1c61-46ce-9b12-5d80493a50d0.webp"
                alt="LipSync Tutorial"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black/70 text-white p-4 text-center">
                "Hello, I am Emma. Welcome to LipSync tutorial!"
              </div>
            </div>
            <div className="p-4 space-y-4">
              <h3 className="font-semibold">Passo a passo simples</h3>
              <ol className="space-y-2 text-sm text-muted-foreground">
                <li className="flex items-center">
                  <span className="bg-primary/20 text-primary rounded-full h-5 w-5 flex items-center justify-center mr-2 text-xs">1</span>
                  <span>Escolha o personagem</span>
                </li>
                <li className="flex items-center">
                  <span className="bg-primary/20 text-primary rounded-full h-5 w-5 flex items-center justify-center mr-2 text-xs">2</span>
                  <span>Escreva o texto em português</span>
                </li>
                <li className="flex items-center">
                  <span className="bg-primary/20 text-primary rounded-full h-5 w-5 flex items-center justify-center mr-2 text-xs">3</span>
                  <span>Traduza para inglês</span>
                </li>
                <li className="flex items-center">
                  <span className="bg-primary/20 text-primary rounded-full h-5 w-5 flex items-center justify-center mr-2 text-xs">4</span>
                  <span>Gere e baixe o vídeo</span>
                </li>
                <li className="flex items-center">
                  <span className="bg-primary/20 text-primary rounded-full h-5 w-5 flex items-center justify-center mr-2 text-xs">5</span>
                  <span>Compartilhe nas redes sociais</span>
                </li>
              </ol>
              <Button 
                variant="link" 
                className="p-0 text-primary" 
                onClick={() => navigate("/lipsync-tutorial")}
              >
                Saiba mais
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LipSyncSection;